const FONT_SIZE_KEY = 'tzn-font-size';
const CONTRAST_KEY = 'tzn-high-contrast';

const applyFontSize = (size) => {
  document.documentElement.style.fontSize = size;
  localStorage.setItem(FONT_SIZE_KEY, size);
};

const applyContrast = (isHigh) => {
  if (isHigh) {
    document.documentElement.classList.add('high-contrast');
    localStorage.setItem(CONTRAST_KEY, 'true');
  } else {
    document.documentElement.classList.remove('high-contrast');
    localStorage.setItem(CONTRAST_KEY, 'false');
  }
};

export const initA11y = () => {
  // Load saved settings
  const savedFontSize = localStorage.getItem(FONT_SIZE_KEY);
  const savedContrast = localStorage.getItem(CONTRAST_KEY);

  if (savedFontSize) {
    document.documentElement.style.fontSize = savedFontSize;
  }
  if (savedContrast === 'true') {
    document.documentElement.classList.add('high-contrast');
  }

  const normalFontBtn = document.querySelector('.a11y__font-btn--normal');
  const mediumFontBtn = document.querySelector('.a11y__font-btn--medium');
  const largeFontBtn = document.querySelector('.a11y__font-btn--large');
  const highContrastBtn = document.querySelector('.a11y__contrast-btn--high');
  const normalContrastBtn = document.querySelector(
    '.a11y__contrast-btn--normal',
  );

  if (normalFontBtn) {
    normalFontBtn.addEventListener('click', () => applyFontSize('62.5%'));
  }
  if (mediumFontBtn) {
    mediumFontBtn.addEventListener('click', () => applyFontSize('75%'));
  }
  if (largeFontBtn) {
    largeFontBtn.addEventListener('click', () => applyFontSize('100%'));
  }
  if (highContrastBtn) {
    highContrastBtn.addEventListener('click', () => applyContrast(true));
  }
  if (normalContrastBtn) {
    normalContrastBtn.addEventListener('click', () => applyContrast(false));
  }

  // Skip link keyboard navigation
  const skipLink = document.querySelector('.skip-link');
  if (skipLink) {
    skipLink.addEventListener('click', (e) => {
      const targetId = skipLink.getAttribute('href');
      if (targetId && targetId.startsWith('#')) {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          targetElement.setAttribute('tabindex', '-1');
          targetElement.focus();
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }
};

